import React, { createContext, useContext } from 'react';
import useUserProfile from '../hooks/useUserProfile';

const UserProfileContext = createContext(null);

export function UserProfileProvider({ children }) {
  const profile = useUserProfile();

  return (
    <UserProfileContext.Provider value={profile}>
      {children}
    </UserProfileContext.Provider>
  );
}

export function useUserProfileContext() {
  const ctx = useContext(UserProfileContext);
  if (!ctx) {
    throw new Error('useUserProfileContext must be used within a UserProfileProvider');
  }
  return ctx;
}

